import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import * as ActionTypes from './types';
import * as API from '../network/api';
import { hlog } from '../common/util';

export const loginChat = () => async (dispatch, getState) => {
  const requestBody = {
    token: getState().user.token,
    userProfileId: getState().user.profile.basicInfo.id
  };
  await axios.post(API.USER_CHAT_LOGIN, requestBody).then(res => {
    if (res.data.code === 200) {
      const { message } = res.data;
      dispatch({
        type: ActionTypes.USER_CHAT_LOGIN,
        payload: message
      });
    }
  }).catch(err => hlog(err));
};

export const getChatDetail = () => async (dispatch, getState) => {
  const requestBody = {
    token: getState().user.token,
    // userProfileId: getState().user.profile.basicInfo.id,
    chatToken: getState().chat.chatToken
  };
  await axios.post(API.USER_CHAT_DETAIL, requestBody).then(res => {
    if (res.data.code === 200) {
      dispatch({
        type: ActionTypes.USER_GET_CHATDETAIL,
        payload: res.data.message
      });
    }
  }).catch(err => hlog(err));
};

export const closeCurrentChatWindow = (message) => (dispatch) => {
  dispatch({
    type: ActionTypes.CLOSE_CURRENT_CHAT_WINDOW,
    message
  });
};

export const closeCurrentGroupChatWindow = (message) => (dispatch) => {
  dispatch({
    type: ActionTypes.CLOSE_CURRENT_GROUPCHAT_WINDOW,
    message
  });
};

export const enterChatRoom = (id, message) => (dispatch) => {
  dispatch({
    type: ActionTypes.ENTER_CHAT_ROOM,
    payload: id,
    chatProfileId: message.chatProfileId
  });
};


export const enterGroupChatRoom = (id, message) => (dispatch) => {
  dispatch({
    type: ActionTypes.ENTER_GROUPCHAT_ROOM,
    payload: id,
    chatProfileId: message.chatProfileId
  });
};

export const createOrEnterChat = (ownerProfileId, viewingProfileId) => async (dispatch, getState) => {
  const { chatDetail } = getState().chat;
  let exist = false;
  if (chatDetail.length !== 0) {
    const result = chatDetail.find(chatInfo =>
      ((chatInfo.users[0].username === viewingProfileId) || chatInfo.users[1].username === viewingProfileId)
      && !chatInfo.name.startsWith('group')
    );

    if (result) {
      exist = true;
      dispatch({
        type: ActionTypes.ENTER_CHAT_ROOM,
        payload: result.chatId,
        chatProfileId: getState().chat.chatProfileId
      });
      return result.chatId;
    }
  }
  if (!exist) {
    const requestBody = {
      token: getState().user.token,
      chatToken: getState().chat.chatToken,
      name: uuidv4(),
      users: [ownerProfileId, viewingProfileId]
    };
    dispatch({
      type: ActionTypes.DISABLE_MESSAGE
    });
    await axios.post(API.CREATE_NEW_CHATROOM, requestBody).then(res => {
      if (res.data.code === 200) {
        const { message } = res.data;
        const msg = {
          chatId: message.chatId
        };
        dispatch({
          type: ActionTypes.CREATE_NEW_CHATROOM,
          payload: message.chatId,
          msg
        });
      }
    }).catch(err => hlog(err));
  }
};

export const createOrEnterGroupChat = (name, member) => (dispatch, getState) => {
  const { chatDetail } = getState().chat;
  let exist = false;
  if (chatDetail.length !== 0) {
    const result = chatDetail.find(chatInfo =>
      chatInfo.name === name && chatInfo.name.startsWith('group')
    );
    if (result) {
      exist = true;
      dispatch({
        type: ActionTypes.ENTER_GROUPCHAT_ROOM,
        payload: result.chatId,
        chatProfileId: getState().chat.chatProfileId
      });
      return result.chatId;
    }
  }
  if (!exist) {
    const requestBody = {
      token: getState().user.token,
      chatProfileId: getState().chat.chatProfileId,
      name,
      users: member,
      chatToken: getState().chat.chatToken
    };
    dispatch({
      type: ActionTypes.DISABLE_MESSAGE
    });
    axios.post(API.CREATE_NEW_CHATROOM, requestBody).then(res => {
      if (res.data.code === 200) {
        const { message } = res.data;
        const msg = {
          chatProfileId: getState().chat.chatProfileId,
          chatId: message.chatId
        };
        dispatch({
          type: ActionTypes.CREATE_NEW_GROUPCHATROOM,
          payload: message.chatId,
          msg
        });
      }
    }).catch(err => hlog(err));
  }
};

export const addNewChat = (message) => {
  hlog('new chat');
  return ({
    type: ActionTypes.ADD_NEW_CHAT,
    payload: message
  });
};


export const receiveNewMessage = (message) => {
  hlog('new message');
  return ({
    type: ActionTypes.RECEIVE_NEW_MESSAGE,
    payload: message
  });
};

export const receiveNewLCMessage = (message) => {
  hlog('new lc message');
  return ({
    type: ActionTypes.RECEIVE_NEW_LCMESSAGE,
    payload: message
  });
};

export const updateMemberStatus = (message) => ({
  type: ActionTypes.UPDATE_USER_STATUS,
  payload: message
});


export const socketInit = () => ({
  type: ActionTypes.SOCKET_INIT
});

export const getFullChatHistory = (currentChatRoom) => async (dispatch, getState) => {
  const requestBody = {
    token: getState().user.token,
    id: currentChatRoom,
    chatProfileId: getState().chat.chatProfileId
  };
  await axios.post(API.GET_FULL_HISTORY, requestBody).then(res => {
    if (res.data.code === 200) {
      const { message } = res.data;
      const result = getState().chat.chatDetail.find(chatInfo => chatInfo.chatId === currentChatRoom);
      if (result.messages.length !== message.length) {
        dispatch({
          type: ActionTypes.UPDATE_TO_FULL_HISTORY,
          payload: message
        });
      }
    }
  }).catch(err => hlog(err));
};

export const sendMessage = (message) => (dispatch) => {
  dispatch({
    type: ActionTypes.SEND_MESSAGE,
    message
  });
};

export const toNormalScroll = () => (dispatch) => {
  dispatch({
    type: ActionTypes.TO_NORMAL_SCROLL
  });
};

export const openMobileChat = () => (dispatch) => {
  dispatch({
    type: ActionTypes.OPEN_MOBILE_CHATWINDOW
  });
};

export const openDialog = () => (dispatch) => {
  dispatch({
    type: ActionTypes.OPEN_DIALOG
  });
};

export const reset = () => (dispatch, getState) => {
  const msg = {
    chatToken: getState().chat.chatToken,
    status: 'offline'
  };
  dispatch({
    type: ActionTypes.RESET_REDUCER_GROUP,
    msg
  });
};

export const enterLC = (chatId) => async (dispatch) => {
  const requestBody = {
    chatId,
    startTime: moment()
  };
  await axios.post(API.GET_LC_HISTORY, requestBody).then(res => {
    if (res.data.code === 200) {
      const { message } = res.data;

      dispatch({
        type: ActionTypes.SET_LC_STATUS,
        message,
        chatId
      });
    }
  }).catch(err => hlog(err));
};

export const sendLCMessage = (message) => (dispatch) => {
  dispatch({
    type: ActionTypes.SEND_LC_MESSAGE,
    message
  });
};




// WEBPACK FOOTER //
// ./src/components/actions/chat.js